import * as React from 'react';
import { useRouter } from 'next/router';
import { LoadingBar } from '@packages/ui';
import { useInterval, usePageTransition } from '@packages/common';

export const LoadingBarContainer: React.FC = () => {
  const router = useRouter();
  const [progress, setProgress] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  const handleStart = (url: string) => {
    url !== router.pathname && setLoading(true);
  };

  React.useEffect(() => {
    if (loading) {
      setProgress(0);
    }
  }, [loading]);
  const handleComplete = () => {
    setLoading(false);
  };

  useInterval(() => {
    if (loading) {
      setProgress((progress) => progress + Math.floor(Math.random() * 10));
    } else {
      setProgress(100);
    }
  }, 100);

  usePageTransition({
    start: handleStart,
    complete: handleComplete,
    error: handleComplete,
  });

  return <LoadingBar progress={progress}></LoadingBar>;
};
